<template>
  <ActionsMenu v-bind="props">
    <template #trigger><slot name="trigger"></slot></template>
  </ActionsMenu>
</template>

<script setup lang="ts">
// This now renders the vue Actions Menu
import { Props } from "tippy.js";

import ActionsMenu from "@/components/ActionsMenu.vue";

interface Action {
  label: string;
  icon?: string;
  eventName: string;
  className?: string;
  visible?: boolean;
  disabled?: boolean;
  source?: string;
  html?: string;
}

const props = defineProps<{
  item?: any;
  actions: Action[];
  options?: Props;
  placement?: "top" | "bottom" | "left" | "right";
}>();
</script>
